import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "./firebase";
import { OneOffPayment } from "../@types/oneOffPayment";

const oneOffPaymentsCollection = (userId: string) =>
  collection(db, "users", userId, "oneOffPayments");

export async function getOneOffPayments(
  userId: string
): Promise<OneOffPayment[]> {
  const snapshot = await getDocs(oneOffPaymentsCollection(userId));
  return snapshot.docs.map((d) => d.data() as OneOffPayment);
}

/**
 * Written by the POS right after a one-off charge succeeds. The Stripe
 * webhook and the reconcile route write the same doc id (the payment intent
 * id) as backstops, and every writer skips docs that already exist, so
 * whichever lands first wins and the rest are no-ops.
 */
export async function createOneOffPayment(
  userId: string,
  payment: OneOffPayment
): Promise<void> {
  const ref = doc(oneOffPaymentsCollection(userId), payment.uid);
  const existing = await getDoc(ref);
  if (existing.exists()) return;
  await setDoc(ref, payment);
}

/**
 * Corrects the tax flag on a charge after the fact. The POS defaults the
 * "Amount includes sales tax" switch to on whenever the account has a tax
 * rate, so out-of-state charges get flagged by mistake. This is reporting
 * only: the amount charged never changes. Writes the same shape the POS
 * writes when the switch is off (taxIncluded false, taxRate 0).
 */
export async function updateOneOffPaymentTax(
  userId: string,
  paymentUid: string,
  taxIncluded: boolean,
  taxRate: number
): Promise<void> {
  const ref = doc(oneOffPaymentsCollection(userId), paymentUid);
  await updateDoc(ref, {
    taxIncluded,
    taxRate: taxIncluded ? taxRate : 0,
  });
}
